<template>
  <span @mousemove.stop class="card__new_contents">novos conteúdos</span>
</template>

<script>
export default {
  name: "NewContentEventFlag"
};
</script>

<style scoped>
.card__new_contents {
  position: absolute;
  background-color: var(--primary-color);
  width: 100%;
  height: 36px;
  left: 0;
  top: 0;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  font-size: 12px;
  font-weight: bolder;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
